import { createAsyncThunk } from "@reduxjs/toolkit";
import { getChatReport, getHumanServiceChats, getClientUsers, getHumanCategoriesAll, getTableColumnNames } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Chat Report Table Column Names
export const fetchChatReportTableColumnNames = createAsyncThunk(
  "chatReport/fetchChatReportTableColumnNames",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);


// Fetch Chat Report
export const fetchChatReport = createAsyncThunk(
  "chatReport/fetch",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getChatReport(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching chat report");
    }
  }
);

// Fetch Human Categories
export const fetchHumanCategoriesAll = createAsyncThunk(
  "chatReport/fetchHumanCategories",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getHumanCategoriesAll(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching human categories");
    }
  }
);

// Get Client Users
export const fetchClientUsers = createAsyncThunk(
  "chatReport/fetchClientUsers",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getClientUsers(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching client users");
    }
  }
);

// Add Human Categories
export const fetchHumanServiceChats = createAsyncThunk(
  "chatReport/fetchChats",
  async (chatReport, { rejectWithValue }) => {
    try {
      const response = await getHumanServiceChats(chatReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching chats");
    }
  }
);